module.exports = __webpack_public_path__ + "static/ribbon_customize-a4ec495c1af4f2bf5b99e9a05c4b56e4.png";